{
  "LABEL_MGMT": {
    "HEADER": "Etiquetas",
    "HEADER_BTN_TXT": "Adicionar etiqueta",
    "LOADING": "A procurar etiquetas",
    "DESCRIPTION": "As etiquetas ajudam-no a categorizar e priorizar conversas e leads. Pode atribuir uma etiqueta a uma conversa ou entrar em contacto usando o painel lateral.",
    "LEARN_MORE": "Saber mais sobre etiquetas",
    "SEARCH_404": "Não existem itens correspondentes à sua pesquisa",
    "LIST": {
      "404": "Não há etiquetas disponíveis nesta conta.",
      "TITLE": "Gerir etiquetas",
      "DESC": "As etiquetas permitem agrupar conversas.",
      "TABLE_HEADER": {
        "NAME": "Nome:",
        "DESCRIPTION": "Descrição",
        "COLOR": "Cor"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Nome da etiqueta",
        "PLACEHOLDER": "Nome da etiqueta",
        "REQUIRED_ERROR": "Nome da etiqueta obrigatório",
        "MINIMUM_LENGTH_ERROR": "A etiqueta deve ter, no mínimo, 2 caracteres",
        "VALID_ERROR": "Apenas são permitidas letras, números, hífen e underscores"
      },
      "DESCRIPTION": {
        "LABEL": "Descrição",
        "PLACEHOLDER": "Descrição da etiqueta"
      },
      "COLOR": {
        "LABEL": "Cor"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Mostrar etiqueta na barra lateral"
      },
      "EDIT": "Editar",
      "CREATE": "Criar",
      "DELETE": "Excluir",
      "CANCEL": "Cancelar"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Adicionar etiqueta à conversa",
        "MULTIPLE_SUGGESTION": "Selecionar esta etiqueta",
        "DESELECT": "Desmarcar etiqueta",
        "DISMISS": "Descartar sugestão"
      },
      "POWERED_BY": "IA",
      "DISMISS": "Descartar",
      "ADD_SELECTED_LABELS": "Adicionar etiquetas selecionadas",
      "ADD_SELECTED_LABEL": "Adicionar etiqueta selecionada",
      "ADD_ALL_LABELS": "Adicionar todas as etiquetas",
      "SUGGESTED_LABELS": "Etiquetas sugeridas"
    },
    "ADD": {
      "TITLE": "Adicionar etiqueta",
      "DESC": "As etiquetas permitem agrupar conversas.",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta adicionada com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro, por favor, tente novamente"
      }
    },
    "EDIT": {
      "TITLE": "Editar etiqueta",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta atualizada com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro, por favor, tente novamente"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "API": {
        "SUCCESS_MESSAGE": "Etiqueta excluída com sucesso",
        "ERROR_MESSAGE": "Ocorreu um erro, por favor, tente novamente",
        "IN_USE_ERROR": "Esta etiqueta não pode ser excluída porque está a ser utilizada em {usages}. Remova-a primeiro desses registos.",
        "IN_USE_FILTERS": "filtros: {names}",
        "IN_USE_AUTOMATIONS": "regras de automação: {names}",
        "IN_USE_MACROS": "macros: {names}"
      },
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem a certeza que pretende excluir ",
        "YES": "Sim, excluir ",
        "NO": "Não, manter "
      }
    }
  }
}
